import { debug } from "../../utils";
import { RuleExpectedCondition } from "../../vars";

export const ACTION_RULE_CHANGED = "ACTION_RULE_CHANGED";
export const ACTION_TARGET_TYPES_LOADED = "ACTION_TARGET_TYPES_LOADED";
export const ACTION_STATE_CLEANED = "ACTION_STATE_CLEANED";
export const ACTION_LAST_RULE_LOAD_CHANGED = "ACTION_LAST_RULE_LOAD_CHANGED";
export const ACTION_RULE_REVERTED = "ACTION_RULE_REVERTED";

const initState = {
    rule: {
        deviceTypes: [],
        locations: [],
        compliance: [],
        sectors: [],
        msbList: [],
        groups: [],
        sectionName: '',
        subsectionName: '',
        // conditions: [{type: RuleExpectedCondition.CONTAINS, output: '', order: 0, ruleScript: ''}],
        scripts: [{ script: '', order: 0, conditions: [{ type: RuleExpectedCondition.CONTAINS, output: '', order: 0 }] }],
        severity: 'Low',
    },
    lastRuleLoad: 0,
    targetTypesLoading: true
}

export function AddRulesPageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_RULE_CHANGED: {
            debug(`AddRulesPageReducer ${ACTION_RULE_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_TARGET_TYPES_LOADED: {
            debug(`AddRulesPageReducer ${ACTION_TARGET_TYPES_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_LAST_RULE_LOAD_CHANGED: {
            debug(`AddRulesPageReducer ${ACTION_LAST_RULE_LOAD_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULE_REVERTED: {
            debug(`AddRulesPageReducer ${ACTION_RULE_REVERTED} is being processed...`)
            return { ...state, ...initState };
        }
        case ACTION_STATE_CLEANED: {
            debug(`AddRulesPageReducer ${ACTION_STATE_CLEANED} is being processed...`)
            return initState;
        }
        default:
            return state;
    }
}
